import { LabelsType } from '../types';

type Props = {
    currentYear: number;
    graphData: { year: number; totalValue: number; deposits: number }[];
    showRelativeNumberOfYears?: boolean;
    getLabel: (key: keyof LabelsType, replacements?: Record<string, string | number>) => string;
    formatNumber: (number: number) => string;
};

export const Table = ({ currentYear, graphData, showRelativeNumberOfYears, getLabel, formatNumber }: Props) => {
    return (
        <div className="r-overflow-y-auto r-rounded-xl md:r-mx-4 md:r-max-h-72">
            <table className="r-w-full r-border-collapse r-text-gray-700">
                <thead>
                    <tr className="r-border-b r-border-gray-300">
                        <th scope="col" className="r-py-3 r-pr-4 r-text-left r-font-bold">
                            {getLabel('year')[0].toUpperCase() + getLabel('year').slice(1)}
                        </th>
                        <th scope="col" className="r-py-3 r-text-right r-font-bold">
                            {getLabel('finalAmount')}
                        </th>
                        <th scope="col" className="r-py-3 r-text-right r-font-bold">
                            {getLabel('depositAmount')}
                        </th>
                    </tr>
                </thead>

                <tbody>
                    {graphData.map(point => (
                        <tr key={point.year} className="focus-within-double-outline r-border-b r-border-gray-200 hover:r-bg-[#f5f5f5]">
                            <td className="r-py-3 r-pr-4">
                                {point.year === 0
                                    ? getLabel('today')
                                    : showRelativeNumberOfYears
                                      ? `${getLabel('year').charAt(0).toUpperCase()}${getLabel('year').slice(1)} ${point.year}`
                                      : `${currentYear + point.year}`}
                            </td>
                            <td className="r-py-3 r-text-right r-font-bold">{formatNumber(Math.round(point.totalValue))}</td>
                            <td className="r-py-3 r-text-right">{formatNumber(point.deposits)}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};
